import Icon from '../icons/icon';
import { QuipliLink } from '../link/quipli-link';
import { Tooltip } from '../tooltip/tooltip';
import { Typography } from '../typography/typography';
import './pretty-descriptor.scss';

export const PrettyDescriptor = ({
  title,
  description = '',
  required = false,
  tooltipText = undefined,
  tooltipUrl = undefined,
}: {
  title: string;
  description?: string;
  required?: boolean;
  tooltipText?: string;
  tooltipUrl?: string;
}) => {
  return (
    <div className="flex flex-col">
      <Typography type="text-md" weight="regular" className="flex flex-row items-center gap-1">
        {title}
        {required && <p className="required">*</p>}
        {tooltipText !== undefined &&
          (tooltipUrl ? (
            <Tooltip
              tooltip={
                <QuipliLink to={tooltipUrl} target="_blank">
                  <div className="p-[12px]">
                    <Typography type="text-sm" className="!text-quipli-white-50 underline">
                      {tooltipText}
                    </Typography>
                  </div>
                </QuipliLink>
              }
              type="black"
              maxWidth={'309px'}
            >
              <Icon icon={'HelpCircle'} />
            </Tooltip>
          ) : (
            <Tooltip tooltip={tooltipText} type="black" maxWidth={'309px'}>
              <Icon icon={'HelpCircle'} />
            </Tooltip>
          ))}
      </Typography>
      <Typography type="text-sm" className="text-grey-500">
        {description}
      </Typography>
    </div>
  );
};
